import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypeBackground {
    secondary: string;
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: ["Helvetica Neue", "Helvetica", "Arial", "sans-serif"].join(
      ",",
    ),
    h1: {
      fontFamily: '"Times New Roman", serif',
      fontSize: "3rem",
      lineHeight: "3.6rem",
      WebkitTextStroke: "0.5px currentColor",
      "@media (min-width:600px)": {
        fontSize: "5rem",
        lineHeight: "6rem",
      },
      "@media (min-width:900px)": {
        fontSize: "6rem",
        lineHeight: "7.2rem",
      },
      "@media (min-width:1200px)": {
        fontSize: "7rem",
        lineHeight: "8rem",
      },
    },
    h2: {
      textAlign: "left",
      fontSize: "1.5rem",
      lineHeight: "2rem",
      "@media (min-width:600px)": {
        fontSize: "2rem",
        lineHeight: "2.5rem",
      },
      "@media (min-width:900px)": {
        fontSize: "2.5rem",
        lineHeight: "3rem",
      },
    },
    h4: {
      fontWeight: 300,
      fontSize: "1.5rem",
      lineHeight: 1.6,
      "@media (min-width:600px)": {
        fontSize: "1.75rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1.75rem",
      },
    },
    h5: {
      fontWeight: 300,
      fontSize: "1.1rem",
      lineHeight: 1.6,
      "@media (min-width:600px)": {
        fontSize: "1.25rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1.5rem",
      },
    },
    h6: {
      fontWeight: 300,
    },
  },
  palette: {
    text: {
      primary: "#ffffff",
      secondary: "#E4E7DE",
    },
    background: {
      default: "#1D1D1D",
      paper: "#4D5B4E",
      secondary: "#393939",
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: "text.primary",
      },
    },
    MuiSvgIcon: {
      defaultProps: {
        color: "inherit",
      },
      styleOverrides: {
        root: {
          color: "#1D1D1D",
        },
      },
    },
  },
});
